/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'chevron-right': {
    viewBox: '0 0 24 24',
    data: `<polygon points="15.032 11.984 9.719 17.297 8.968 16.545 13.529 11.984 8.968 7.423 9.719 6.672 15.032 11.984" style="fill-rule:evenodd"/>`
  }
})
